import {DecoratorNode, $applyNodeReplacement} from 'lexical';

/** Inline base64 image, no resizing. Saved as <img src="data:...">. */
export class ImageNode extends DecoratorNode {
  __src;
  constructor(src = '', key) {
    super(key);
    this.__src = src;
  }
  static getType() { return 'doc-image'; }
  static clone(node) { return new ImageNode(node.__src, node.__key); }
  static importJSON(json) { return $createImageNode(json.src); }
  exportJSON() { return {type: 'doc-image', version: 1, src: this.__src}; }

  createDOM() {
    const el = document.createElement('span');
    el.className = 'de-image-wrap';
    return el;
  }
  updateDOM() { return false; }
  isInline() { return true; }
  exportDOM() {
    const el = document.createElement('img');
    el.setAttribute('src', this.__src);
    el.setAttribute('alt', '');
    return {element: el};
  }
  static importDOM() {
    return {
      img: (dom) => ({
        conversion: () => ({node: $createImageNode(dom.getAttribute('src') || '')}),
        priority: 1,
      }),
    };
  }
  decorate() { return <img className="de-image" src={this.__src} alt="" />; }
}

export const $createImageNode = (src) => $applyNodeReplacement(new ImageNode(src));
export const $isImageNode = (n) => n instanceof ImageNode;
